import SonyS from "../ImagesPro/Sony speaker.png";
import Apple from "../ImagesPro/Imouse.png";
import RazerH from "../ImagesPro/Razer H.png";
import BoatI from "../ImagesPro/Boat Imm.png";
import RazerB from "../ImagesPro/Razer M.png";
import AcerL from "../ImagesPro/Acer L.png";
import OnePlusB from "../ImagesPro/OnePlace b.png";
import BoseB from "../ImagesPro/Bose B.png";
import Rog from "../ImagesPro/ROG L.png";
import OnePlus from "../ImagesPro/OnePlusB.png";
import JblS from "../ImagesPro/jblS.png";
import AsusM from "../ImagesPro/AsusMouse.png";
import LogiT from "../ImagesPro/LogitechC.png";
import Msik from "../ImagesPro/MSIK.png";
import BoseQ from "../ImagesPro/Bose q.png";
import JblT from "../ImagesPro/Jbl T.png";
export const ProductHome = [
  {
    id: "1",
    brand: "Bose Quietcomfort 45",
    description:
      "High-fidelity audio – The TriPort acoustic architecture offers depth and fullness. Volume-optimized Active EQ maintains balanced performance at any volume,",
    price: 14999,
    mark_price: "19,999",
    categories: "headphones",
    img: BoseQ,
  },
  {
    id: "2",
    brand: "JBL Tune 510BT",
    description:
      "JBL PURE BASE SOUND: Packed with 32mm Dynamic drivers, the JBL Tune 510BT features the renowned JBL Pure Bass sound, which can be found in the most famous......",
    price: 2229,
    mark_price: "5,990",
    categories: "headphones",
    img: JblT,
  },
  {
    id: "1",
    brand: "SONY HT-S20R ",
    description:
      "Dolby Digital Subwoofer Rear Speakers400W  Bluetooth Soundbar 400 W Bluetooth Soundbar (Black, 5.1 Channel)",
    price: 14999,
    mark_price: "19,999",
    categories: "speaker",
    img: SonyS,
  },
  {
    id: "2",
    brand: "APPLE MLA02ZM/A Magic 2",
    description:
      "APPLE MLA02ZM/A Magic 2 Wireless Touch Mouse with Bluetooth (White)",
    price: 4999,
    mark_price: "7,499",
    categories: "mouse",
    img: Apple,
  },
  {
    id: "3",
    brand: "Razer Huntsman V2",
    description:
      "Razer Huntsman V2 - Optical (Clicky Purple Switch)RZ03-03930300-R3M1 Wired USB Gaming Keyboard (Black)",
    price: 15999,
    mark_price: "24,999",
    categories: "keyboard",
    img: RazerH,
  },
  {
    id: "4",
    brand: "boAt Immortal IM1300",
    description:
      "The Immortal series brings you one of a kind, Dual Mode Gaming Headphones",
    price: 3999,
    mark_price: "9,999",
    categories: "headphones",
    img: BoatI,
  },
  {
    id: "5",
    brand: "Razer Basilisk V3 Pro",
    description:
      "Customizable - HyperScroll Tilt Wheel - RZ01-04620100-R3A1 Wireless Optical Gaming Mouse with Bluetooth (Classic Black)",
    price: 13999,
    mark_price: "27,999",
    categories: "mouse",
    img: RazerB,
  },
  {
    id: "6",
    brand: "Acer Predator Neo",
    description:
      "Core i7 13th Gen - (16 GB/512 GB SSD/Windows 11 Home /6 GB Graphics/NVIDIA GeForce RTX 4050)  PHN16-71-747H Gaming Laptop",
    price: 121999,
    mark_price: "1,56,999",
    categories: "laptop",
    img: AcerL,
  },
  {
    id: "7",
    brand: "OnePlus Buds Pro 2",
    description:
      "A new version of the 169 firmware is now available for the OnePlus Buds Pro 2/2R. The latest release further optimizes..",
    price: 10999,
    mark_price: "13,999",
    categories: "earbuds",
    img: OnePlusB,
  },
  {
    id: "8",
    brand: "Bose QuietComfort Earbuds II",
    description:
      "Bose QuietComfort Earbuds II with Active Noise  Cancellation (ANC) Bluetooth Headset (Black, True Wireless)",
    price: 21999,
    mark_price: "25,900",
    categories: "earbuds",
    img: BoseB,
  },
  {
    id: "9",
    brand: "ASUS ROG Zephyrus M16",
    description:
      "90WHr Battery Intel H-Series Core i9 13th Gen - (32 GB/2 TB SSD/Windows 11 Home/16 GB Graphics/NVIDIA ...",
    price: 364990,
    mark_price: "4,31,990",
    categories: "laptop",
    img: Rog,
  },
  {
    id: "10",
    brand: "Bose Quiet comfort",
    description:
      "High-fidelity audio – The TriPort acoustic architecture offers depth and fullness. Volume-optimized Active..",
    price: 19999,
    mark_price: "29,999",
    categories: "headphones",
    img: BoseQ,
  },
  {
    id: "11",
    brand: "OnePlus Buds Z2",
    description:
      "High Quality Sound: 11mm dynamic drivers acoustically  tuned for bigger, bolder beats with razor-sharp treble",
    price: 4598,
    mark_price: "5,999",
    categories: "earbuds",
    img: OnePlus,
  },
  {
    id: "12",
    brand: "JBL Boombox 2",
    description:
      "Own the party. From backyard barbecues to weekend road trips, JBL Boombox 2 brings it with monstrous bass..",
    price: 29997,
    mark_price: "45,999",
    categories: "speaker",
    img: JblS,
  },
  {
    id: "13",
    brand: "ASUS ROG Chakram X",
    description:
      "ASUS ROG Chakram X Origin Gaming Mouse Wireless Optical Gaming Mouse ",
    price: 10999,
    mark_price: "13,999",
    categories: "mouse",
    img: AsusM,
  },
  {
    id: "14",
    brand: "Logitech Combo Touch for iPad Pro",
    description:
      "ou can add ease to your daily tablet use with the Logitech Combo Touch iPad Keyboard. It makes it simple to ..",
    price: 18994,
    mark_price: "23,900",
    categories: "keyboard",
    img: LogiT,
  },
  {
    id: "15",
    brand: "MSI GT77 Titan",
    description:
      "MSI GT77 Titan Core i9 12th Gen - (64 GB/2 TB SSD/Windows 11 Home/16 GB Graphics/NVIDIA GeForce RTX 3080Ti/120 Hz)..",
    price: 450000,
    mark_price: "5,26,990",
    categories: "laptop",
    img: Msik,
  },
];
export default ProductHome;
